import api from './api'

export const authService = {
  /** `email` field may be an email address or username (API contract). */
  login: async (emailOrUsername, password) => {
    const response = await api.post('/auth/login', { email: emailOrUsername, password })
    return response.data
  },
  
  register: async (userData) => {
    const response = await api.post('/auth/register', userData)
    return response.data
  },

  /** Returns { available: boolean } — public endpoint */
  checkUsername: async (username, signal) => {
    const response = await api.get('/auth/check-username', {
      params: { username: username ?? '' },
      ...(signal ? { signal } : {}),
    })
    return response.data
  },

  /** Returns { available: boolean } — public endpoint; use valid email shape */
  checkEmail: async (email, signal) => {
    const response = await api.get('/auth/check-email', {
      params: { email: email ?? '' },
      ...(signal ? { signal } : {}),
    })
    return response.data
  },
  
  registerParent: async (parentData) => {
    const response = await api.post('/auth/register/parent', parentData)
    return response.data
  },
  
  /**
   * Body matches ChildCreate. `parent_id` is optional — the API resolves the parent from the JWT
   * (and creates a minimal Parent row if missing). Pass `parentId` only if you need to assert a value.
   */
  registerChild: async (childPayload, parentId) => {
    const body = { ...childPayload }
    if (parentId != null && parentId !== '') {
      body.parent_id = parentId
    }
    const response = await api.post('/auth/register/child', body)
    return response.data
  },
  
  getCurrentUser: async () => {
    const response = await api.get('/auth/me')
    return response.data
  },
  
  refreshToken: async (refreshToken) => {
    const response = await api.post('/auth/refresh', { refresh_token: refreshToken })
    return response.data
  },
  
  logout: async () => {
    const response = await api.post('/auth/logout')
    return response.data
  },
  
  getChildren: async () => {
    const response = await api.get('/auth/children')
    return response.data
  },

  /** Parent or school staff: set a new password for a child account. */
  resetChildPassword: async (childId, password) => {
    const response = await api.post(`/auth/children/${childId}/reset-password`, {
      password,
    })
    return response.data
  },
}
